// src/components/Navbar.js
import React from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../assets/badamilogo.png";

const Navbar = () => {
  const navLinkClass = ({ isActive }) =>
    isActive
      ? "text-[#4C47DC] font-medium transition-colors"
      : "text-gray-800 hover:text-[#4C47DC] transition-colors";

  return (
    <nav className="bg-white shadow-sm h-20">
      <div className="max-w-7xl mx-auto px-6 h-full flex justify-between items-center">
        {/* Clickable Logo + Brand Name */}
        <Link to="/" className="flex items-center space-x-1">
          <img
            src={logo}
            alt="Badami Labs Logo"
            className="h-10 w-auto object-contain"
          />
          <span className="text-3xl font-bold text-[#4C47DC] leading-none">
            Badami Labs
          </span>
        </Link>

        {/* Navigation Links */}
        <div className="space-x-6 text-sm md:text-base">
          <NavLink to="/" className={navLinkClass}>
            Home
          </NavLink>
          <NavLink to="/about" className={navLinkClass}>
            About
          </NavLink>
          <NavLink to="/services" className={navLinkClass}>
            Services
          </NavLink>
          <NavLink to="/contact" className={navLinkClass}>
            Contact
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
